requirejs.config({ baseUrl: variables.base_url, paths: { app: '../app', components: '../components' }, urlArgs(e, s) { return (s.indexOf('?') === -1 ? '?' : '&') + asset_version; } });
